// utils/enrollmentApi.js
// Centralised API helper for batch-course self-enrollment endpoints.
import apiClient from './apiClient';

const ER = '/enrollment-requests';

// ═══════════════════════ STUDENT ═══════════════════════

export const getCatalogCourses = () =>
  apiClient.get(`${ER}/catalog`);

export const getCatalogCourseDetail = (courseId) =>
  apiClient.get(`${ER}/catalog/${courseId}`);

export const applyToCourse = (payload) =>
  apiClient.post(`${ER}/apply`, payload);

export const verifyEnrollmentPayment = (payload) =>
  apiClient.post(`${ER}/verify-payment`, payload);

export const getMyRequests = () =>
  apiClient.get(`${ER}/my-requests`);

// ═══════════════════════ ADMIN ═══════════════════════

export const getEnrollmentRequests = (params = {}) =>
  apiClient.get(`${ER}/admin/list`, { params });

export const getCourseBatchesForEnrollment = (courseId) =>
  apiClient.get(`${ER}/admin/course-batches/${courseId}`);

export const approveRequest = (id, payload = {}) =>
  apiClient.put(`${ER}/admin/${id}/approve`, payload);

export const rejectRequest = (id, payload = {}) =>
  apiClient.put(`${ER}/admin/${id}/reject`, payload);
